import type { DrillRow, ScoringMode } from '../lib/api';
import { formatMagazines } from '../lib/magazines';

interface Props {
  drill: DrillRow;
  onPicked: (mode: ScoringMode) => void;
  onBack: () => void;
}

/**
 * Step 2 of the round-setup flow: referee picks the output mode.
 * Any drill can be shot in either mode — schema kind only governs
 * the keypad layout, not the scoring metric.
 */
export function ModePicker({ drill, onPicked, onBack }: Props) {
  return (
    <section className="space-y-4">
      <header className="flex items-center justify-between">
        <button onClick={onBack} className="min-h-12 pr-3 text-sm text-zinc-500 underline">
          ← zurück
        </button>
        <h2 className="text-lg font-bold">Wertungsart wählen</h2>
      </header>

      <p className="text-sm text-zinc-400">
        <span className="font-medium text-zinc-200">{drill.drill.name}</span> ·{' '}
        {drill.drill.shotCount} Schuss
        {formatMagazines(drill.drill.magazines)
          ? ` (${formatMagazines(drill.drill.magazines)})`
          : ''}{' '}
        · {drill.targetName}
      </p>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <button
          onClick={() => onPicked('precision')}
          className="flex flex-col items-start gap-2 rounded-xl border border-zinc-700 bg-zinc-900 px-5 py-6 text-left transition-colors hover:border-emerald-500 hover:bg-zinc-800"
        >
          <span className="text-3xl">🎯</span>
          <span className="text-2xl font-bold">Präzision</span>
          <span className="text-sm text-zinc-400">Summe der Punkte. Zeit optional.</span>
        </button>

        <button
          onClick={() => onPicked('speed')}
          className="flex flex-col items-start gap-2 rounded-xl border border-zinc-700 bg-zinc-900 px-5 py-6 text-left transition-colors hover:border-amber-500 hover:bg-zinc-800"
        >
          <span className="text-3xl">⏱️</span>
          <span className="text-2xl font-bold">Speed</span>
          <span className="text-sm text-zinc-400">Punkte pro Sekunde. Zeit erforderlich.</span>
        </button>
      </div>
    </section>
  );
}
